import { createFileRoute } from "@tanstack/react-router";

import { AdminKakekomiNewPage } from "@/features/admin/kakekomi/kakekomi-new-page";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/kakekomi/new")({
  staticData: { crumb: { label: "開催回を追加" } },
  component: AdminKakekomiNewPage,
});
